import ExpandablePanel from './ExpandablePanel';

export default ExpandablePanel;
